const benefits = [
  { icon: "ri-vip-crown-2-fill", title: "专属会员标识", desc: "金色皇冠标识，醒目又高级，走到哪里都是焦点。" },
  { icon: "ri-speed-line", title: "高清语音优先", desc: "高峰期优先接入高品质语音通道，开黑不卡顿。" },
  { icon: "ri-shapes-line", title: "专属头像装扮", desc: "独享会员头像框、气泡与主题装扮，随心搭配。" },
  { icon: "ri-gift-2-line", title: "每日专属礼包", desc: "每日登录领取会员礼物与积分，持续积累更多权益。" },
  { icon: "ri-headphone-line", title: "客服优先响应", desc: "专属服务通道，问题处理更快，体验更省心。" },
  { icon: "ri-coupon-3-line", title: "活动折扣特权", desc: "充值、活动礼包专享折扣，用得更省更尽兴。" },
];

export default function Membership() {
  return (
    <section id="membership" className="relative bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-secondary-400">
            <i className="ri-vip-crown-2-line" aria-hidden="true"></i>
            会员权益
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-50">开通会员，解锁更多热爱</h2>
          <p className="mx-auto mt-4 max-w-2xl text-foreground-300">
            从身份标识到专属特权，从游戏加成到活动折扣，歪歪会员让每一次登录都更有价值。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {benefits.map((item) => (
              <article
                key={item.title}
                className="rounded-xl border border-background-200/70 bg-background-50 p-5 md:p-6"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-500/15 text-secondary-400">
                    <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading text-base md:text-lg text-foreground-50">{item.title}</h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-400">{item.desc}</p>
              </article>
            ))}
          </div>

          <aside className="rounded-xl border border-primary-400/40 bg-gradient-to-b from-primary-500/15 to-accent-500/10 p-6 md:p-7 flex flex-col">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-xl text-foreground-50">歪歪尊享会员</h3>
              <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-semibold text-background-950">年卡</span>
            </div>
            <p className="mt-4 text-foreground-200">一次开通，全年畅享全部会员特权</p>
            <div className="mt-4 flex items-end gap-1">
              <span className="font-heading text-4xl text-primary-400">¥198</span>
              <span className="mb-1 text-sm text-foreground-400">/ 年</span>
            </div>
            <p className="mt-1 text-xs text-foreground-500">月均约 ¥16.5，省近 40%</p>

            <ul className="mt-6 space-y-3 text-sm text-foreground-100">
              {["六大会员特权全部解锁", "年卡额外赠送 3 个月时长", "专属客服优先通道", "新权益免费升级体验"].map((li) => (
                <li key={li} className="flex items-center gap-2.5">
                  <i className="ri-checkbox-circle-fill text-accent-400" aria-hidden="true"></i>
                  {li}
                </li>
              ))}
            </ul>

            <a
              href="#recharge"
              className="mt-7 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-base font-semibold text-background-950 hover:bg-primary-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-vip-crown-fill" aria-hidden="true"></i>
              立即开通
            </a>
            <p className="mt-4 text-center text-xs text-foreground-500">支持月卡 · 季卡 · 年卡多种选择</p>
          </aside>
        </div>
      </div>
    </section>
  );
}